export const environment = {
  production:false,
  API_URL: 'https://pwlb.agylsoft.app',
  API_NOTIFICATION:'https://wbskpwrlk.agylsoft.app',
  API_MOBILEPAY: 'https://validator.movilpay.app',

  // For Firebase JS SDK v7.20.0 and later, measurementId is optional
  firebase:{
    apiKey: "AIzaSyDUFjR9zEbHnJB6Sn0t2D4Glmkt9DCHPvs",
    authDomain: "powerlink-webpush.firebaseapp.com",
    projectId: "powerlink-webpush",
    storageBucket: "powerlink-webpush.appspot.com",
    messagingSenderId: "17510339743",
    appId: "1:17510339743:web:ab4bf630051f834910beaa",
    measurementId: "G-CDBVWH2ZMX",
    vpaidkey:"BOmYKYvrIgeYPM3RRPy5njvtHSRib6WOzdlEl-VICRcaYPpuw336LZJahmgdDyEfDbGCy28NMvj4LrISo2ZVvuE",
  }
};
